<template>
  <div class="d-flex">
    <PostsTab
      v-for="tab in visibleTabs"
      :tab="tab"
      :key="tab.id"
      :active="tab.value === active"
      :disabled="tab.disabled"
      @click.native="!tab.disabled && $emit('activate', tab.value)"
    />
  </div>
</template>

<script>
import PostsTab from "@/views/posts/PostsTab";
export default {
  name: "PostTabWrapper",

  components: {
    PostsTab
  },

  model: {
    prop: "active",
    event: "activate"
  },

  props: {
    active: {
      required: true,
      type: Number
    },
    tabs: {
      required: true,
      type: Array
    }
  },
  computed: {
    visibleTabs() {
      return this.tabs.filter(tab => !tab.hidden);
    }
  }
};
</script>
